import React from 'react';
import { Link } from 'react-router-dom';
import '../Pages.css';
import PageHero from '../../components/Common/PageHero';

const Tools: React.FC = () => {
  const toolsData = [
    {
      id: 'alpha-analyzer',
      title: 'Alpha Analyzer',
      description: 'Advanced alpha generation analysis tool based on our proprietary 7-step investment process. Identify high-alpha opportunities through systematic screening.',
      icon: '🎯',
      path: '/tools/alpha-analyzer',
      status: 'Available'
    },
    {
      id: 'portfolio-analyzer',
      title: 'Portfolio Analyzer',
      description: 'Analyze portfolio performance, risk metrics, and optimization opportunities using our systematic approach.',
      icon: '📊',
      path: '/tools/portfolio-analyzer',
      status: 'Coming Soon'
    },
    {
      id: 'risk-calculator',
      title: 'Risk Calculator',
      description: 'Calculate risk-adjusted returns and portfolio volatility metrics using our quantitative models.',
      icon: '⚖️',
      path: '/tools/risk-calculator',
      status: 'Coming Soon'
    },
    {
      id: 'market-sentiment',
      title: 'Market Sentiment Tracker',
      description: 'Track market sentiment indicators and their impact on investment opportunities.',
      icon: '📈',
      path: '/tools/market-sentiment',
      status: 'Available'
    }
  ];

  return (
    <div className="tools-page">
      <PageHero
        title="Investment Tools"
        subtitle="Access our suite of professional investment tools powered by our systematic approach and quantitative analysis framework."
        className="tools-hero"
      />

      <section className="tools-overview">
        <div className="section-container">
          <div className="tools-content">
            <h2>Professional Investment Tools</h2>
            <p className="tools-description">
              Our investment tools are built on the same systematic principles that power Third Locust's 
              investment process. Each tool leverages our proprietary quantitative models and proven methodologies.
            </p>
            
            <div className="tools-grid">
              {toolsData.map(tool => (
                <div key={tool.id} className="tool-card">
                  <div className="tool-icon">{tool.icon}</div>
                  <div className="tool-content">
                    <h3>{tool.title}</h3>
                    <p>{tool.description}</p>
                    <div className="tool-status">
                      <span className={`status-badge ${tool.status === 'Available' ? 'available' : 'coming-soon'}`}>
                        {tool.status}
                      </span>
                    </div>
                    {tool.status === 'Available' ? (
                      <Link to={tool.path} className="btn-primary">
                        Launch Tool
                      </Link>
                    ) : (
                      <button className="btn-secondary" disabled>
                        {tool.status}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="tools-info">
        <div className="section-container">
          <div className="info-content">
            <h2>About Our Tools</h2>
            <div className="info-grid">
              <div className="info-item">
                <h3>Systematic Approach</h3>
                <p>All tools are built using our proven 7-step investment process and quantitative screening methodologies.</p>
              </div>
              <div className="info-item">
                <h3>Professional Grade</h3>
                <p>Enterprise-level tools designed for serious investors who demand precision and reliability.</p>
              </div>
              <div className="info-item">
                <h3>Continuous Updates</h3>
                <p>Regular updates with the latest market data and enhanced features based on our ongoing research.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tools;
